import { PaginatedDataDTO } from '@bottega52/commons-pagination';
import { TypedObject } from '@bottega52/commons-types';
import { Accordion, AccordionDetails, AccordionSummary, Button, Card, IconButton, Link, Tooltip } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { Business, Domain, Edit, InfoOutlined, LanguageOutlined, LinkOutlined } from '@material-ui/icons';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CustomersIcon from '@material-ui/icons/Group';
import _ from 'lodash';
import * as React from "react";
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import { connect, ConnectedProps } from 'react-redux';
import { IState } from '../../redux/store';
import { ICustomerInDTO } from '../../repository/jago/model/input/ICustomerInDTO';
import { IDomainSubscriptionInDTO } from '../../repository/jago/model/input/IDomainConfigInDTO';
import { IDomainDetailedDTO } from '../../repository/jago/model/input/IDomainDetailedDTO';
import { DomainIrisStatusOptions } from '../../repository/jago/model/input/IDomainInDTO';
import { IDomainUserInDTO } from '../../repository/jago/model/input/IDomainUserInDTO';
import { IPlantThemeInDTO } from '../../repository/jago/model/input/IPlantThemeInDTO';
import { getDomainNameFromHostname } from '../../repository/utils';
import AbilityProvider from '../../services/PermissionService/AbilityProvider';
import { PERMISSIONS, Roles } from '../../services/PermissionService/PermissionConstants';
import { BLUE, RED } from '../../style/StyleConsts';
import Permission from '../Permission/Permission';
import ReduxLanguage from '../ReduxLanguage';
import DomainAdditionalInfo from './DomainAdditionalInfo';
import DomainInfoView from './DomainInfoView';
import DomainAppConfigurationView from './DomainAppConfigurationView';
import DomainSecretsView from './DomainSecretsView';
import DomainSubscriptionList from './DomainSubscriptions/DomainSubscriptionList';
import DomainUsersList from './DomainUsers/DomainUsersList';

const styles = createStyles({
  container: {
    display: 'flex',
    margin: 10,
    flexDirection: 'column',
    paddingBottom: 50,
  },
  rowBodyContainer: {
    padding: 15,
    minHeight: 100,
  },
  rowTitle: {
    fontWeight: 'bold',
    fontSize: 25,
  },
  logo: {
    width: '20%',
  },
  sectionTitle: {
    fontWeight: 'bold'
  },
  sectionSubtitle: {
    fontWeight: 100,
    lineHeight: '1.5em',
  },
  configurationContainer: {
    display: 'flex',
    margin: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  accordionBodyContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  sectionHeader: {
    display: 'flex',
    flexDirection: 'column',
  },
  domainHeaderContainer: {
    padding: 10,
    marginTop: 10,
    borderLeft: '3px solid #0D47A1',
  },
  domainHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  domainHeaderInner: {
    display: 'flex',
    flexDirection: 'row',
  },
  domainHeaderTextContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  domainIcon: {
    marginTop: 10,
    marginRight: 5,
    fontSize: 25,
  },
  domainTypeContainer: {
    width: 'fit-content',
    height: 'fit-content',
    padding: 3,
    paddingLeft: 15,
    paddingRight: 15,
    backgroundColor: BLUE,
    borderRadius: 5,
  },
  domainTypeText: {
    color: 'white',
    fontWeight: 'bold',
  },
  tooltipContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  federatedContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    fontSize: 15
  },
  installationModeCardContainer: {
    width: '100%',
    marginTop: 5,
    marginBottom: 5,
    display: 'flex',
    flexDirection: 'row',
  },
  installationModeInnerContainer: {

  }
});

interface ConfigJsonValidatorDTO {
  plainText: string;  //	A string representation of then content which includes linebreaks and indentation.
  markupText: string //	A string representation of the auto-generated markup used to render content.
  json: string; //	A JSON.stringify version of content.
  jsObject: TypedObject<any>; 	//A javascript object version of content. Will return undefined if the content's syntax is incorrect.
  lines: number;	//Number of lines rendered for content to be displayed.
  error: any;
}

export interface IDomainDetailsViewState {
  hasConfigError: boolean;
  configToSave?: ConfigJsonValidatorDTO;
  initialPlantThemeId: number;
  plantThemeSelected: IPlantThemeInDTO;
}

type IDomainDetailsViewReduxProps = ConnectedProps<typeof connector>;

export interface IDomainDetailsViewProps extends WithStyles<typeof styles>, IDomainDetailsViewReduxProps {
  detailedDomain: IDomainDetailedDTO | {};
  onSaveConfig: (config: string) => void;
  onImpersonateUser: (user: IDomainUserInDTO) => void;
  onAppenDomainUsers: (page: number) => void;
  onNewUserClick: () => void;
  onNewInstallerClick: () => void;
  onExtendDomainClick?: () => void;
  onUpdateAddionalInfo: (note: string) => void;
  onGatewaysClick: () => void;
  onOpenCustomerDetails?: (customerId: number) => void;
  onSavePlantTheme?: (plantId: number, plantThemeId: number, addOrRemove: boolean) => void;
  onDeletePlantRequest: () => void;
  onDeleteDomainUserRequest: (user: IDomainUserInDTO) => void;
  onEditPlantSocDetails?: (domain: IDomainDetailedDTO) => void;
}

class DomainDetailsView extends React.Component<IDomainDetailsViewProps, IDomainDetailsViewState> {

  constructor(props: IDomainDetailsViewProps) {
    super(props);

    const domain = !_.isEmpty(props.selectedDetailedDomain) ? (props.selectedDetailedDomain as IDomainDetailedDTO) : null;
    const initialPlantThemeId = domain?.plantThemeId?domain.plantThemeId:null;
    const plantThemesData = props.plantThemes&&(props.plantThemes as PaginatedDataDTO<IPlantThemeInDTO>).content?
      (props.plantThemes as PaginatedDataDTO<IPlantThemeInDTO>).content:[]
    const plantThemeSelected_initial = initialPlantThemeId&&plantThemesData.filter(e=>e.id===initialPlantThemeId).length>0?
      plantThemesData.filter(e=>e.id===initialPlantThemeId)[0]:null

    this.state = {
      hasConfigError: false,
      initialPlantThemeId: initialPlantThemeId,
      plantThemeSelected: plantThemeSelected_initial,
    }
  }

  onConfigurationChange(content: ConfigJsonValidatorDTO) {
    if (content && content.error && !_.isEmpty(content.error)) {
      this.setState({ hasConfigError: true });
    } else {
      this.setState({ configToSave: content, hasConfigError: false });
    }
  }

  onOpenConfigGuide() {
    window.open('https://drive.google.com/drive/folders/1K9fHOmQ7CsCUlDYqfo7io3virq8ovW2v?usp=sharing')
  }

  onSaveConfig() {
    const { onSaveConfig } = this.props;
    const { configToSave } = this.state;
    if (configToSave) {
      onSaveConfig(configToSave.json);
    }
  }

  onSavePlantTheme() {
    const { onSavePlantTheme, selectedDetailedDomain } = this.props;
    const { plantThemeSelected, initialPlantThemeId } = this.state;
    const domain = !_.isEmpty(selectedDetailedDomain) ? (selectedDetailedDomain as IDomainDetailedDTO) : null;
    if (domain&&onSavePlantTheme&&(initialPlantThemeId||(plantThemeSelected?.id))) {
      if (!(plantThemeSelected?.id)&&initialPlantThemeId)
        onSavePlantTheme(domain.id,initialPlantThemeId,false)
      if (plantThemeSelected?.id)
        onSavePlantTheme(domain.id,plantThemeSelected.id,true)
    }
  }

  onDomainUserClick(user: IDomainUserInDTO) {
    const { onImpersonateUser } = this.props;
    onImpersonateUser(user);
  }
  
  onFetchMoreUsers(page: number) {
    const { onAppenDomainUsers } = this.props;
    onAppenDomainUsers(page);
  }


  onDomainSubscriptionClick(subscription: IDomainSubscriptionInDTO) {

  }

  onOpenCustomerDetails(customer?: ICustomerInDTO) {
    if (customer && customer.id) {
      const { onOpenCustomerDetails } = this.props;
      onOpenCustomerDetails(customer.id);
    }
  }

  async onPlantThemeSelected(newValue: string | IPlantThemeInDTO) {
    const newValue_plantTheme = !newValue?null:(newValue as IPlantThemeInDTO)
    this.setState({ plantThemeSelected: newValue_plantTheme })
  }

  public render() {
    const { selectedDetailedDomain, classes, onExtendDomainClick, onOpenCustomerDetails, onUpdateAddionalInfo, onDeletePlantRequest, onNewInstallerClick, onGatewaysClick, onNewUserClick, onDeleteDomainUserRequest, onEditPlantSocDetails } = this.props;
    const { hasConfigError } = this.state;

    const domain = !_.isEmpty(selectedDetailedDomain) ? (selectedDetailedDomain as IDomainDetailedDTO) : null;
    if (!domain || _.isEmpty(domain)) return <div />;
    const federatedMasterDomain = domain?.subscriptionDomainHostname ? getDomainNameFromHostname(domain?.subscriptionDomainHostname) : false;
    const isMasterDomainOfFederation = federatedMasterDomain && federatedMasterDomain === domain?.name;
    const domainSegment = domain.subSegment ? domain.subSegment : domain.segmentType;
    return (
      <div className={classes.container}>
        <Card className={classes.domainHeaderContainer}>
          <div className={classes.domainHeader}>
            <div className={classes.domainHeaderInner}>
              <div className={classes.domainHeaderTextContainer}>
                <h2 className={classes.rowTitle}>{domain.appId} - {domain.name}</h2>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 5 }}>
                  <LanguageOutlined style={{ fontSize: 18, color: '#3f3f3f' }} />
                  <h3 style={{ color: '#3f3f3f' }}>{domain.hostname}</h3>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 5 }}>
                  <Domain style={{ fontSize: 18, color: '#3f3f3f' }} />
                  <h3 style={{ color: '#3f3f3f' }}>{domainSegment ? <ReduxLanguage languageKey={`segmentTypes.${domainSegment}_name`} /> : ''}</h3>
                </div>
                <Permission abilityHelper={AbilityProvider.getAbilityHelper()} roles={[Roles.ROLE_VASHO_SOFIA_ADMIN, Roles.ROLE_VASHO_LOCAL_SOC_MANAGER, Roles.ROLE_VASHO_GLOBAL_SOC_MANAGER]}>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 5 }}>
                    <LinkOutlined style={{ fontSize: 18, color: '#3f3f3f' }} />
                    <h3 style={{ color: '#3f3f3f' }}>ZenDesk Id: {domain.zenDeskId || '--'}</h3>
                    <h3 style={{ color: '#3f3f3f' }}>Lockbase Id: {domain.lockbaseId || '--'}</h3>
                    <h3 style={{ color: '#3f3f3f' }}>1RIS License: {domain.license1ris || '--'}</h3>
                    {onEditPlantSocDetails ? (
                      <IconButton size="medium" onClick={() => onEditPlantSocDetails(domain)} style={{ marginLeft: 10 }}>
                        <Edit style={{ fontSize: 18 }} />
                      </IconButton>
                    ) : null}
                  </div>
                </Permission>
                <div>
                  
                </div>
                {onOpenCustomerDetails ? (
                  <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.CUSTOMER_READ}>
                    {domain?.customer ? (
                      <Link href="#" onClick={() => this.onOpenCustomerDetails(domain.customer)}>
                      <div className={classes.federatedContainer} style={{ cursor: 'pointer', marginLeft: 5 }}>
                        <CustomersIcon style={{ color: 'cornflowerblue', fontSize: 18 }} />
                        <h3 style={{ textDecoration: 'underline', color: 'cornflowerblue' }}>{domain.customer.name}</h3>
                      </div>
                      </Link>
                    ): null}
                  </Permission>
                ):null}
                {federatedMasterDomain ? (
                  <div className={classes.federatedContainer} style={{ marginLeft: 5 }}>
                    <Business className={classes.icon}/>
                    {isMasterDomainOfFederation ? (
                      <h4><ReduxLanguage languageKey="domains.federatedMasterDomain" /></h4>
                    ) : (
                      <h4><ReduxLanguage languageKey="domains.federatedDomain" languageProps={{ domain: federatedMasterDomain }}/></h4>
                    )}
                  </div>
                ): null}
              </div>
            </div>
            <div className={classes.tooltipContainer}>
              {federatedMasterDomain ? (
                <Tooltip title={<ReduxLanguage languageKey="domains.federatedDomainsDescription" />} placement="left" arrow>
                  <Card className={classes.domainTypeContainer} style={{ marginRight: 10 }}>
                    <h5 className={classes.domainTypeText}>{<ReduxLanguage languageKey='domains.federatedDomains' />}</h5>
                  </Card>
                </Tooltip>
              ) : null}
              {domain.enable1ris && domain.enable1ris === DomainIrisStatusOptions.ENABLED ? (
                <Card className={classes.domainTypeContainer}>
                  <h5 className={classes.domainTypeText}><ReduxLanguage languageKey={'domains.domainIrisEnabled'} /></h5>
                </Card>
              ) : null}
              {domain.domainType ? (
                <Tooltip title={<ReduxLanguage languageKey={domain.domainTypeDescription || ''} />} placement="left" arrow>
                  <Card className={classes.domainTypeContainer}>
                    <h5 className={classes.domainTypeText}>{domain.domainType}</h5>
                  </Card>
                </Tooltip>
              ) : null}
            </div>
          </div>
          <DomainInfoView
            domainInfo={domain.info}
            installationMode={domain.info.installationMode}
            onGatewaysClick={AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.GATEWAYS)? (() => onGatewaysClick()) : (()=>{})}
          />
          <DomainAdditionalInfo
            onUpdateAddionalInfo={(value) => onUpdateAddionalInfo(value)}
            note={domain.note ? domain.note : ''}
          />
        </Card>
        <DomainSecretsView plantId={domain.id} />
        <DomainAppConfigurationView domainHostname={domain.hostname} />
        {!domain.cloudCredits ? (
          <Accordion style={{ marginTop: 20 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <div className={classes.sectionHeader}>
                <h3 className={classes.sectionTitle}><ReduxLanguage languageKey="domains.domainSubsriptionTitle" /></h3>
                <h4 className={classes.sectionSubtitle}><ReduxLanguage languageKey="domains.domainSubsriptionDescription" /></h4>
                {federatedMasterDomain ? (
                  <h4 className={classes.sectionSubtitle}>
                    <ReduxLanguage languageKey="domains.domainFederatedLicense" languageProps={{ domain: federatedMasterDomain }}/>
                  </h4>
                ) : null
                }
                <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.DOMAIN_EXTEND}>
                  <Button
                    variant="contained"
                    style={{ backgroundColor: '#5AC0B1', width: '100%', marginTop: 20, color: 'white' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (onExtendDomainClick) onExtendDomainClick();
                    }}
                  >
                    <ReduxLanguage languageKey="domains.extendDomain" />
                  </Button>
                </Permission>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <DomainSubscriptionList
                subscriptions={domain.subscriptions}
              />
              </AccordionDetails>
          </Accordion>
        ) : null}
        <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.DOMAIN_MANAGER_UPDATE}>
          <Accordion style={{ marginTop: 20 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <div className={classes.sectionHeader}>
                <h3 className={classes.sectionTitle}><ReduxLanguage languageKey="domains.domainUsersTitle" /></h3>
                <h4 className={classes.sectionSubtitle}><ReduxLanguage languageKey="domains.domainUsersDescription" /></h4>
                <h5 className={classes.sectionSubtitle} style={{ color: 'red', fontWeight: 'bold' }}><ReduxLanguage languageKey="domains.domainUsersWarning" /></h5>
                <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.DOMAIN_MANAGER_CREATE}>
                  <Button
                    variant="contained"
                    style={{ backgroundColor: '#5AC0B1', marginTop: 20, color: 'white' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      onNewUserClick()
                    }}
                  >
                    <ReduxLanguage languageKey="forms.createNewUser" />
                  </Button>
                </Permission>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <DomainUsersList
                users={domain.users}
                onRowClick={(user) => this.onDomainUserClick(user)}
                onDeleteUserRequest={(user) => onDeleteDomainUserRequest(user)}
                onFetchMoreItems={(page) => this.onFetchMoreUsers(page)}
              />
              </AccordionDetails>
          </Accordion>
        </Permission>
        
        <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.DOMAIN_INSTALLER_UPDATE}>
          <Accordion style={{ marginTop: 20 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <div className={classes.sectionHeader}>
                <h3 className={classes.sectionTitle}><ReduxLanguage languageKey="domains.domainInstallersTitle" /></h3>
                <h4 className={classes.sectionSubtitle}><ReduxLanguage languageKey="domains.domainInstallersDescription" /></h4>
                <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.DOMAIN_INSTALLER_CREATE}>
                  <Button
                    variant="contained"
                    style={{ backgroundColor: '#5AC0B1', marginTop: 20, color: 'white' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      onNewInstallerClick()
                    }}
                  >
                    <ReduxLanguage languageKey="forms.createNewInstaller" />
                  </Button>
                </Permission>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <DomainUsersList
                users={domain.installers}
                onFetchMoreItems={(page) => this.onFetchMoreUsers(page)}
                onDeleteUserRequest={(user) => onDeleteDomainUserRequest(user)}
              />
              </AccordionDetails>
          </Accordion>
        </Permission>

        <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.DOMAIN_DELETE_REQUEST}>
          <Accordion style={{ marginTop: 20 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <div className={classes.sectionHeader}>
                <h3 className={classes.sectionTitle}><ReduxLanguage languageKey="domains.domainDeletionTitle" /></h3>
                <h4 className={classes.sectionSubtitle}><ReduxLanguage languageKey="domains.domainDeletionDescription" /></h4>
                
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <Button
                variant="contained"
                style={{ backgroundColor: RED, marginTop: 20, color: 'white' }}
                onClick={(e) => {
                  e.stopPropagation();
                  onDeletePlantRequest()
                }}
              >
                <ReduxLanguage languageKey="forms.deleteDomain" />
              </Button>
              </AccordionDetails>
          </Accordion>
        </Permission>

        <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.DOMAIN_CONFIG}>
          <Accordion style={{ marginTop: 20 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <div className={classes.sectionHeader}>
                <h3 className={classes.sectionTitle}><ReduxLanguage languageKey="domains.domainConfigTitle" /></h3>
                <h4 className={classes.sectionSubtitle}><ReduxLanguage languageKey="domains.domainConfigDescription" /></h4>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className={classes.accordionBodyContainer}>
                <div className={classes.infoContainer}>
                  <IconButton onClick={() => this.onOpenConfigGuide()}>
                    <InfoOutlined style={{ color: '#3f51b5' }} />
                  </IconButton>
                  <Link href="#" onClick={() => this.onOpenConfigGuide()}>
                    <h4><ReduxLanguage languageKey="domains.domainConfigGuide" /></h4>
                  </Link>
                </div>
                <Card>
                  <JSONInput
                    id= 'parser'
                    placeholder={domain.config}
                    locale={ locale }
                    onChange={(content: ConfigJsonValidatorDTO) => this.onConfigurationChange(content)}
                    height='350px'
                    width="80vh"
                  />
                </Card>
                <Button
                  disabled={hasConfigError}
                  variant="contained"
                  style={{ backgroundColor: '#5AC0B1', marginTop: 20 }}
                  onClick={() => this.onSaveConfig()}
                >
                  <ReduxLanguage languageKey="forms.save" />
                </Button>
              </div>
            </AccordionDetails>
          </Accordion>
        </Permission>

        {/* 
        {onSavePlantTheme ? (
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.VAR_PLANT_THEME}>
            <Accordion style={{ marginTop: 20 }} defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <div className={classes.sectionHeader}>
                  <h3 className={classes.sectionTitle}><ReduxLanguage languageKey="vars.domainThemeTitle" /></h3>
                  <h4 className={classes.sectionSubtitle}><ReduxLanguage languageKey="vars.domainThemeDescription" /></h4>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className={classes.accordionBodyContainer}>
                  <div style={{marginTop:-10}}>
                    <h5 style={{ fontWeight: 'normal' }}>{<ReduxLanguage languageKey={'vars.plantThemeSearch'} />}</h5>
                    <Select
                      key={`select_modal_select_key`}
                      isClearable
                      value={plantThemeSelected}
                      options={plantThemeOptions}
                      isSearchable={false}
                      placeholder={<ReduxLanguage languageKey={'vars.plantThemeSearchEnterName'} />}
                      onChange={(e) => {this.onPlantThemeSelected(e)}}
                      formatOptionLabel={(o) => <><b>{o.name}</b></>}
                      required
                      isOptionSelected={(o) => plantThemeSelected&&plantThemeSelected.id?plantThemeSelected.id === o.id:false}
                      styles={{
                        menu: (styles) => Object.assign(styles, { zIndex: 1000, width: 600 }),
                        control: (styles) => ({ ...styles, minHeight: 55, width: 600 }),
                      }} 
                    />
                  </div>
                  {plantThemeSelected&&plantThemeSelected.logoUrl?(
                    <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',width:'100%',height:180,marginTop:10,marginBottom:10}}>
                      <div style={{display:'flex',flexDirection:'column',marginRight:50,alignItems:'center'}}>
                        <h3 style={{ fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'vars.plantThemeColourDescription'} />}</h3>
                        <div style={{borderRadius:50,width:50,height:50,backgroundColor:plantThemeSelected.colour}}></div>
                      </div>
                      <img src={plantThemeSelected.logoUrl} alt="logo" style={{maxWidth:180,maxHeight:180,objectFit:'contain'}} />
                    </div>
                  ):null}
                  <Button
                    disabled={!(domain&&(initialPlantThemeId||(plantThemeSelected?.id)))}
                    variant="contained"
                    style={{ backgroundColor: (domain&&(initialPlantThemeId||(plantThemeSelected?.id)))?'#5AC0B1':'grey', marginTop: 20, color: 'white' }}
                    onClick={() => this.onSavePlantTheme()}
                  >
                    <ReduxLanguage languageKey="forms.save" />
                  </Button>
                </div>
              </AccordionDetails>
            </Accordion>
          </Permission> 
        ) : null}
        */}
      </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
    selectedDetailedDomain: state.domains.selectedDetailedDomain,
    plantThemes: state.vars.plantThemes.data,
  };
}

const connector = connect(mapStateToProps);
export default connector(withStyles(styles)(DomainDetailsView));
